import { el, setChildren } from 'redom';

import AttachmentsPanel from '../attachments-panel';
import AddAttachmentButton from '../file-upload-button';
import InlineImageButton from '../inline-image-button';
import AILevelButton from '../ai-level-button';
import BookmarksButton from '../bookmarks-button';

import SendButton from './send-button';

import './index.scss';

class MessageEditorSecondaryControls {

  constructor(configuration) {

    this.onImage = configuration.onImage;
    this.disableAI = configuration.disableAI === true;
    this.attachmentsPanel = new AttachmentsPanel(configuration);
    this.addAttachmentButton = new AddAttachmentButton({
      onAttachment: (file) => this.attachmentsPanel.addFiles([file])
    });
    this.inlineImageButton = new InlineImageButton(configuration);
    this.sendButton = new SendButton(configuration);
    this.enableBookmarks = configuration.enableBookmarks === true;
    this.bookmarksConfiguration = configuration.bookmarks;
    this.internetPhone = configuration.internetPhone;
    this.displaySendButton = configuration.displaySendButton;

    const children = [];

    if (this.enableBookmarks === true && this.bookmarksConfiguration.bookmarks.length > 0) {

      this.bookmarksButton = new BookmarksButton({
        bookmarks: configuration.bookmarks,
        conversation: configuration.conversation
      });

      children.push(this.bookmarksButton);

    }

    if (this.disableAI === false) {
      this.aiLevelButton = new AILevelButton({
        internetPhone: configuration.internetPhone,
        conversation: configuration.conversation,
        onChange: configuration.onAILevelChange
      });

      if (configuration.conversation.metadata.assistantConversation !== true) {
        children.push(this.aiLevelButton);
      }
    }

    children.push(this.inlineImageButton,
      el('#attachment-controls', [
        this.addAttachmentButton,
        this.attachmentsPanel
      ]));

    if (this.displaySendButton === true) {
      children.push(this.sendButton);
    }

    this.el = el('.message-editor-secondary-controls', children);

  }

  addFiles(files) {
    this.attachmentsPanel.addFiles(files);
  }

  update(configuration) {

    const children = [];

    if (this.enableBookmarks === true && this.bookmarksConfiguration.bookmarks.length > 0) {

      children.push(this.bookmarksButton);

    }

    if (this.disableAI === false) {

      if (configuration.conversation.metadata.assistantConversation !== true) {
        children.push(this.aiLevelButton);
        this.aiLevelButton.update(configuration);
      }
    }

    children.push(this.inlineImageButton,
      el('#attachment-controls', [
        this.addAttachmentButton,
        this.attachmentsPanel
      ]));

    if (this.displaySendButton === true) {
      children.push(this.sendButton);
    }

    setChildren(this.el, children);

    this.inlineImageButton.update(configuration);
    this.attachmentsPanel.update(configuration);
    this.sendButton.setEnabled(configuration.enableSend && !configuration.outboundDisabled);

  }

}

export default MessageEditorSecondaryControls;